"use client";
import {
  useCheckboxStore
} from "../__chunks/HAVBGUA3.js";
import {
  CheckboxContextProvider
} from "../__chunks/RNCDFVMF.js";
import "../__chunks/LMDWO4NN.js";
import "../__chunks/YV4JVR4I.js";
import "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/checkbox/checkbox-provider.tsx
import { jsx } from "react/jsx-runtime";
function CheckboxProvider(props = {}) {
  const store = useCheckboxStore(props);
  return /* @__PURE__ */ jsx(CheckboxContextProvider, { value: store, children: props.children });
}
export {
  CheckboxProvider
};
